module.exports = __webpack_public_path__ + "img/waffels.9158ec6d.svg";